import { Procedure } from 'interfaces/procedure';
import { DisplayedField } from '../../genericFields';
import { biopsyDateField } from './caseFields';
import { getUpdatePathForProcedureClinicalDataField } from './helpers';

import { formatDateTimeForUser } from 'utils/dateTime';
import {
  artifactsField,
  biopsyTypeField,
  encodingField,
  formatField,
  maxResolutionField,
  numOfChannelsField,
  objectiveMagnificationField,
  originalFileNameField,
  preservationMethodField,
  procedureTypeField,
  qcFailedField,
  scanDateField,
  scannerManufacturerField,
  scannerModelField,
  tsmAreaField,
} from './slideFields';

export const caseCreationDateField: DisplayedField<Procedure, string> = {
  filterType: 'date-range',
  dataCategory: 'metadata',
  dataKey: 'createdAt',
  label: 'Creation Date',
  isFullDate: true,
  views: ['day', 'month', 'year'],
  columnWidth: { width: 150 },
  valueFormatter(params, _context) {
    return formatDateTimeForUser(params.value);
  },
};

export const dateOfMetastasisField: DisplayedField<Procedure, string> = {
  // TODO: set `cellEditType: 'date',` if/when we allow clinical data editing
  filterType: 'date-range',
  dataCategory: 'clinical',
  dataKey: 'date_of_metastasis',
  label: 'Date of Metastasis',
  isFullDate: true,
  views: ['day', 'month', 'year'],
  columnWidth: { width: 120 },
  valueGetter: (procedure) => procedure?.clinicalData?.dateOfMetastasis,
  updatePath: getUpdatePathForProcedureClinicalDataField('dateOfMetastasis'),
};

export default [
  originalFileNameField,
  formatField,
  caseCreationDateField,
  biopsyDateField,
  scanDateField,
  biopsyTypeField,
  procedureTypeField,
  preservationMethodField,
  scannerModelField,
  scannerManufacturerField,
  dateOfMetastasisField,
  artifactsField,
  qcFailedField,
  tsmAreaField,
  objectiveMagnificationField,
  maxResolutionField,
  numOfChannelsField,
  encodingField,
];
